import { render, staticRenderFns } from "./ProductVariationTemporaryPricing.vue?vue&type=template&id=590acca9&"
import script from "./ProductVariationTemporaryPricing.vue?vue&type=script&lang=js&"
export * from "./ProductVariationTemporaryPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports